import { render, staticRenderFns } from "./self-introduction.vue?vue&type=template&id=829657e4&scoped=true"
import script from "./self-introduction.vue?vue&type=script&lang=js"
export * from "./self-introduction.vue?vue&type=script&lang=js"
import style0 from "./self-introduction.vue?vue&type=style&index=0&id=829657e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829657e4",
  null
  
)

export default component.exports